import _ from 'lodash'

export default {
	data() {
		return {
			
		}
	},
	props: [],
	created(){
		
	},
	methods: {
		
	},
	computed:{
		getTotalSurfaces(){
			return this.$store.getters.getTotalSurfaces
		},
	},
	components:{
		
	}
}